<!-- =========================================================================================
  File Name: addRoomSidebar.vue
  Description: Add New Manager Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isRoomSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h3>ADD ROOM FOR:</h3>
         <vs-chip  color="primary" class="mr-8">
      <p >{{dataLocationName}}</p>
    </vs-chip>
        <feather-icon icon="XIcon" @click.stop="isRoomSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <vs-row>
    <vs-col vs-w="12">
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <!-- <div class="p-6" >
        <div class="flex">
          <vs-checkbox v-model="NewBox" @change="newcheck(NewBox)">Add New</vs-checkbox>
        </div>
        <br>
        <div v-if="ExBox">
        <label class="vs-select--label w-full">Select Existing Room</label>
        <v-select  v-if="ExBox" label="name"  multiple :closeOnSelect="true" v-model="dataRoom"  :options="rooms"   />
        </div>

      </div> -->
      <!-- <div class="pl-6 pr-6 pt-0" v-if="NewBox"> -->
      <div class="p-6">

        <!-- FIRST NAME -->
        <vs-input label="Name *"   v-model="dataName" class="w-full" name="name" v-validate="'required'" maxlength="50" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>


      </div>
    </component>
     </vs-col>
    </vs-row>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{ $t('user.add.btn_submit') }}</vs-button>
      <vs-button type="border" color="danger" @click.native="isRoomSidebarActiveLocal = false">{{ $t('user.add.btn_cancel') }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

import {
  CREATE_LOCATION_ROOM,
  ALL_ROOMS,
  UPDATE_LOCATION_ROOMS
} from '@/graphql'

export default {
  props: {
    isRoomSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      Duplicate:0,
      UserDuplicate:0,
      alphanumeric:0,
      ExBox:true,
      NewBox:false,
      dataId: null,
      dataLocationName:'',
      rooms:[],
      dataRoom:[],
      ImgName:'',
      dataImg:'',
      oldimage:'',
      dataName: '',
      dataLastName: '',
      dataNickName: '',
      dataUserName: '',
      dataEmail: '',
      dataPhone: '',
      checkImg:'',
      dataLocation: [],
      dataStatus: true,
      dataPassword: '',
      dataConfPassword: '',
      dataEmailConfirmed: false,
      dataEmailInviteOption: true,
      PassField: true,
      enableInvitOption: true,
      UserDuplicate: 0,
      emailDuplicate: 0,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      enableBtn:true
    }
  },
  watch: {
    isRoomSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, rooms, name} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataRoom = rooms
        this.dataLocationName = name
        const getrooms = []
        const getroomsids = []
        for (let j = 0; j < rooms.length; j++) {
          getroomsids.push(rooms[j].id)
          getrooms.push(rooms[j])
        }
        this.dataRoom = getrooms
        this.enableBtn=true
      }
    }
  },
  computed: {
    isRoomSidebarActiveLocal: {
      get () {
        return this.isRoomSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeRoomSidebar')
          // this.$validator.reset()
          // this.ExBox = true
          // this.NewBox = false
          this.initValues()
        }
      }
    },
    isFormValid () {
      
      return !this.errors.any() && this.dataName && this.enableBtn
      // if (this.ExBox) {
      //   return !this.errors.any() && this.dataRoom.length > 0
      // }
      // if (this.NewBox) {
      //   return !this.errors.any() && this.dataName
      // }

    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      // this.dataRoom = []
      this.dataName = ''
      // this.ExBox = true
      // this.NewBox = false
    },
    StatusRoomSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Location',
        text:  'Room added successfully',
        color: 'success',
        position: 'top-right'
      })
    },

    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Location',
        text:  'Manager added successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    submitData () {
      // if (this.NewBox) {
      this.$validator.validateAll().then(result => {
        if (result) {
          const locations = []
          locations.push(this.dataId)
          this.enableBtn=false
          this.$apollo
            .mutate({
              mutation: CREATE_LOCATION_ROOM,
              variables: {
                name: this.dataName,
                location:this.dataId
              }
            }).then(response => {
              if (response.data.createlocationRoom.status == 'SUCCESS') {
                 this.enableBtn=true
                this.StatusRoomSuccess()
                this.$validator.reset()
                this.initValues()
                this.$emit('closeRoomSidebar')
              }
            }).catch(error => {
              console.log(error)
               this.enableBtn=true
            })
        }
      })
      // }
      // if (this.ExBox) {
      //   this.$validator.validateAll().then(result => {
      //     const getroomsids = []
      //     for (let j = 0; j < this.dataRoom.length; j++) {
      //       const getid = this.dataRoom[j].id
      //       getroomsids.push(getid)
      //     }
      //     if (result) {
      //       this.$apollo
      //         .mutate({
      //           mutation: UPDATE_LOCATION_ROOMS,
      //           variables: {
      //             id:this.dataId,
      //             rooms: getroomsids
      //           }
      //         })
      //         .then(response => {
      //           if (response) {
      //             this.StatusSuccess()
      //             this.$emit('closeRoomSidebar')
      //             this.$emit('getdata', true)
      //             this.$validator.reset()
      //             this.initValues()
      //           }
      //         }).catch(error => {
      //           console.log(error)
      //         })
      //     }
      //   }
      //   )
      // }
    }
    // excheck (val) {
    //   this.NewBox = !val
    // },
    // newcheck (val) {
    //   this.ExBox = !val
    // }
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    // this.$apollo
    //   .mutate({
    //     mutation: ALL_ROOMS
    //   })
    //   .then(response => {
    //     this.rooms = response.data.Rooms
    //   })
    //    this.$apollo
    //      this.$apollo
    //         .mutate({
    //           mutation: ALL_MANAGERS,
    //         })
    //         .then(response => {
    //           this.managers = response.data.role.users
    //           var managers=[]
    //           for (let i = 0; i<response.data.role.users.length; i++) {
    //           var fullname = response.data.role.users[i].fname+' '+response.data.role.users[i].lname+' - '+response.data.role.users[i].email
    //           response.data.role.users[i].name = fullname;
    //           managers.push(response.data.role.users[i])
    //         }
    //          this.managers=managers
    //         })
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
